import { render, staticRenderFns } from "./Top10TitleSwiper.vue?vue&type=template&id=53c0b87f&scoped=true"
import script from "./Top10TitleSwiper.vue?vue&type=script&setup=true&lang=ts"
export * from "./Top10TitleSwiper.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Top10TitleSwiper.vue?vue&type=style&index=0&id=53c0b87f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c0b87f",
  null
  
)

export default component.exports